module.exports = __webpack_public_path__ + "img/cross_section.a753aa28.jpg";